import {cloneDeep} from 'lodash';
import {toFixed} from 'shared/helpers';

export const getQFPFaceHeights = (
    quantity: number,
    totalHeight: number,
    gap: number,
    currentGap: number,
    manualUpdates: number[],
    currentFaceHeights: number[]
) => {
    let faceHeightValues = cloneDeep(currentFaceHeights);
    let updateGap = false;
    let clearManualEntries = false;
    const faceHeightSum = Math.round(
        currentFaceHeights.reduce((a, b) => a + b, 0)
    );
    // the gap branch keeps its array's length, so it cannot run on a resize
    const countChanged = quantity != currentFaceHeights.length;

    if (currentGap != gap && manualUpdates.length > 0 && !countChanged) {
        updateGap = true;
        const availableHeight =
            totalHeight -
            currentFaceHeights
                .filter((v, index) => manualUpdates.includes(index))
                .reduce((a, b) => a + b);
        const freeFaces = quantity - manualUpdates.length;

        faceHeightValues = currentFaceHeights.map((faceHeight, index) => {
            if (manualUpdates.includes(index)) {
                return faceHeight;
            }

            return toFixed(availableHeight / freeFaces, 2);
        });
    } else if (countChanged || faceHeightSum != totalHeight) {
        faceHeightValues = Array.from(Array(quantity)).map(() =>
            toFixed(totalHeight / quantity, 2)
        );
        // reshared against the new gap, so the caller must stop using the old
        updateGap = true;
        clearManualEntries = true;
    }

    return {
        faceHeightValues,
        updateGap,
        clearManualEntries,
    };
};
